(() => {
  const dialog = document.querySelector('[data-photo-dialog]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const content = dialog.querySelector('[data-photo-content]');
  const stage = dialog.querySelector('.photo-stage');
  const status = dialog.querySelector('[data-photo-status]');
  const caption = dialog.querySelector('[data-photo-caption]');
  const counter = dialog.querySelector('[data-photo-counter]');
  let links = [], index = 0, request = 0, opener;
  const show = () => {
    const link = links[index];
    const ticket = ++request;
    const alt = link.querySelector('img')?.alt || '';
    const image = new Image();
    image.alt = alt;
    stage.setAttribute('aria-busy', 'true');
    status.textContent = status.dataset.loading;
    caption.textContent = "";
    caption.hidden = link.dataset.photoCaption === 'none';
    counter.textContent = `${index + 1} / ${links.length}`;
    image.onload = () => {
      if (ticket !== request || !dialog.open) return;
      content.replaceChildren(image);
      caption.textContent = caption.hidden ? '' : alt;
      stage.setAttribute('aria-busy', 'false');
      status.textContent = '';
      if (links.length > 1) { const next = new Image(); next.src = links[(index + 1) % links.length].href; }
    };
    image.onerror = () => {
      if (ticket !== request || !dialog.open) return;
      content.replaceChildren();
      stage.setAttribute('aria-busy', 'false');
      status.textContent = status.dataset.error;
    };
    image.src = link.href;
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-photo-link]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    const group = link.closest('.launch-gallery, .moments-grid') || document;
    links = Array.from(group.querySelectorAll('[data-photo-link]'));
    index = links.indexOf(link);
    opener = link;
    dialog.showModal();
    show();
  });
  const move = amount => { index = (index + amount + links.length) % links.length; show(); };
  dialog.querySelector('[data-photo-prev]').addEventListener('click', () => move(-1));
  dialog.querySelector('[data-photo-next]').addEventListener('click', () => move(1));
  dialog.querySelector('[data-photo-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('keydown', event => {
    if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
    if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
  });
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('close', () => { request++; content.replaceChildren(); status.textContent = ''; stage.setAttribute('aria-busy', 'false'); opener?.focus({preventScroll: true}); });
})();
